import {useState} from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import BottomMenu from "./Footer/BottomMenu";
import Menu from "./Menu";

import clubStore from "../storage/ClubStore";
import appStore from "../storage/AppStore";


const AppLayout = observer(({items = [], children}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const openMenu = (role) => {
        clubStore.setSelectedMenu(role);
        setMenuOpen(true);
    };

    const bottomButtonClass = (role) => {
        return `bottom-btn${clubStore.selectedMenu === role ? " bottom-btn-active" : ""}`;
    };

    return (
        <>
            {/* =====================================================
                DESKTOP
               ===================================================== */}

            <div className="app-shell desktop">
                <aside className="sidebar">
                    <Menu screen="desktop"/>
                </aside>

                <main className="content">
                    {children}
                </main>
            </div>


            {/* =====================================================
                MOBILE
               ===================================================== */}

            <div className="app-shell mobile">
                <main className="main-content">
                    {children}
                </main>


                <BottomMenu
                    open={menuOpen}
                    onClose={() => setMenuOpen(false)}
                />


                <nav
                    className="bottom-bar"
                    aria-label="Main navigation"
                >
                    {appStore.user.id > 0 &&
                        !appStore.user.is_admin &&
                        appStore.user.companies.length === 0 && (
                            <button
                                type="button"
                                className="bottom-btn"
                                onClick={() => navigate("/add")}
                            >
                                <i className="pi pi-file-edit bottom-btn__icon"/>

                                <span className="bottom-btn__label">
                                    {appStore.tr.add_company}
                                </span>
                            </button>
                        )
                    }

                    {/*{appStore.user.is_admin && (*/}
                    {/*    <button*/}
                    {/*        type="button"*/}
                    {/*        className={bottomButtonClass("admin")}*/}
                    {/*        aria-pressed={clubStore.selectedMenu === "admin"}*/}
                    {/*        onClick={() => openMenu("admin")}*/}
                    {/*    >*/}
                    {/*        <i className="pi pi-crown bottom-btn__icon"/>*/}

                    {/*        <span className="bottom-btn__label">*/}
                    {/*            Admin*/}
                    {/*        </span>*/}
                    {/*    </button>*/}
                    {/*)}*/}

                    {items.map((item) => {
                        const active = clubStore.selectedMenu === item.role;

                        const label = item.role === "company"
                            ? (
                                clubStore.club?.id > 0
                                    ? clubStore.club.name
                                    : appStore.tr.please_select
                            )
                            : item.label;

                        return (
                            <button
                                key={item.role || item.label}
                                type="button"
                                className={bottomButtonClass(item.role)}
                                aria-pressed={active}
                                onClick={() => openMenu(item.role)}
                            >
                                {item.icon && (
                                    <i className={`${item.icon} bottom-btn__icon`}/>
                                )}

                                <span className="bottom-btn__label">
                                    {label}
                                </span>
                            </button>
                        );
                    })}
                </nav>
            </div>
        </>
    );
});


export default AppLayout;